module.exports = __webpack_public_path__ + "static/media/x.d102b73c.svg";